<template>
	<div class="header">
		<div class="logo">
			<img src="../../assets/logo.png" class="icon" />
		</div>
		<div class="search" style="visibility: hidden;">
			<div class="s-box">
				<el-input :placeholder="$t('page.Please_enter_content')" @focus="searchFocus" @blur="searchBlur"
					@input="searchInput" v-model="searchVal" class="head-search">
				</el-input>
				<el-button type="primary" icon="el-icon-search head-search-btn"></el-button>
				<div class="yu-input-val" v-if="yusearch">
					<div class="yu-list">
						<div class="item" v-for="item in 3"><span>{{$t('page.Please_enter_content')}}</span></div>
					</div>
					<el-button type="primary" style="visibility: hidden;" icon="el-icon-search head-search-btn">
					</el-button>
				</div>
			</div>
		</div>
		<div class="swith-language">
			<el-dropdown @command="handleCommand">
			<span command="zh">{{$t('app.English')}}</span>
			<!-- 只有英文 -->
				<!-- <span class="el-dropdown-link">
					{{lan}}<i class="el-icon-arrow-down el-icon--right"></i>
				</span> -->
				<el-dropdown-menu slot="dropdown">
					<!-- <el-dropdown-item command="zh">{{$t('app.Chinese')}}</el-dropdown-item>
					<el-dropdown-item command="en">{{$t('app.English')}}</el-dropdown-item> -->
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<div class="user-head">
			<div class="user-item messHover">
				<div class="icon-box email"></div>
				<div class="item-children mess-children">
					<div class="item-dom">
						<span>{{$t('menu.messages')}}</span>
						<router-link to="/user/message"><span class="clear">{{$t('page.view_all')}}</span></router-link>
					</div>
					<div class="mess-list" v-for="ms in mesList">
						<img src="" class="head" />
						<div class="mess">
							<div class="name">{{ms.title}}</div>
							<div class="desc">{{ms.content}}</div>
							<div class="time">{{ms.createDateTime}}</div>
						</div>
						<span class="delete-not delete-close" @click="handleDelete(ms)"><i
								class="el-icon-close"></i></span>
					</div>
				</div>
			</div>
			<div class="user-item notionHover">
				<div class="icon-box notion"></div>
				<div class="item-children notion-children">
					<div class="item-dom"><span>{{$t('menu.notice')}}</span><span class="clear"
							@click="clearAllNotion">{{$t('page.empty')}}</span></div>
					<div class="notion-list" v-for="ms in ntfList">
						<div class="name">{{ms.title}}</div>
						<span class="delete-not delete-close"><i class="el-icon-close"></i></span>
					</div>
					<div class="look-all">
						<router-link to="/user/notice"><span class="looka">{{$t('page.view_all')}}</span></router-link>
					</div>
				</div>
			</div>
			<div class="user-item userHover">
				<img src="" class="user-toux" />
				<div class="item-children">
					<div class="item" v-for="um in userMenu">
						<router-link :to="um.path">{{$t(`menu.${um.name}`)}}</router-link>
					</div>
					<div class="item" @click="logOut"><a>{{$t('menu.loginOut')}}</a></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	import {
		getAuthorCommentServiceList,
		deleteAuthorCommentService
	} from '../../common/api/comment.js'
	export default {
		name: 'Sidebar',
		data() {
			return {
				userMenu: [{
						name: 'My_creation',
						path: '/work/mywork'
					},
					// {
					// 	name: 'my_assets',
					// 	path: '/user/notice'
					// },
					// {
					// 	name: 'Profile_and_Account',
					// 	path: '/user/message'
					// },
					{
						name: 'setting',
						path: '/setting'
					},
					// {
					// 	name: 'con_info',
					// 	path: '/setting'
					// },
					// {name:'退出',path:'/user/message'},
				],
				searchVal: '',
				yusearch: false,
				mesList: [],
				ntfList: [],
				lan: '',
				reqLoadData: {
					data: {
						page: 1,
						limit: 15,
						commentTypes: [1, 2], //消息（评论）类型：1评论2系统消息。
					}
				}
			}
		},
		computed: {
			language() {
				return localStorage.getItem('language') == 'en' ? 'English' : '中文'
				// return localStorage.getItem('language') == 'zh' ? 'English' : 'English'
				// return localStorage.getItem('language') === 'en'
			}
		},
		created() {
			this.lan = localStorage.getItem('language') == 'en' ? 'English' : '中文'
			// this.lan = localStorage.getItem('language') == 'zh' ? 'English' : 'English'
			// this.lan = localStorage.getItem('language') === 'en' 
			this.loadData()
		},
		methods: {
			...mapMutations(['loginOut']),
			handleCommand(command) {
				localStorage.setItem('language', command)
				this.lan = localStorage.getItem('language') == 'en' ? 'English' : '中文'
				// this.lan = localStorage.getItem('language') == 'zh' ? 'English' : 'English'
				// this.lan = localStorage.getItem('language') === 'en' 
				this.$i18n.locale = command
			},
			logOut() {
				this.$confirm('Are you sure to log out？', 'Tip', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.loginOut()
					this.$router.replace({
						path: '/signIn'
					})
					// location.reload()
				}).catch(() => {

				});
			},
			clearAllNotion() {

			},
			searchFocus(e) {
				console.log(e.event)
				this.yusearch = true
			},
			searchBlur(e) {
				console.log(e.event)
				this.yusearch = false
			},
			searchInput(val) {
				console.log(val)
			},
			loadData() { //加载数据
				let that = this
				this.reqLoadData.data.commentTypes = [1]
				getAuthorCommentServiceList(this.reqLoadData).then(res => {
					// console.log("res", res);
					that.mesList = []
					if (res.code == 0) {
						that.mesList = res.data
					}
				})
			},
			loadNofify() { //加载数据
				let that = this
				this.reqLoadData.data.commentTypes = [2]
				getAuthorCommentServiceList(this.reqLoadData).then(res => {
					// console.log("res", res);
					that.ntfList = []
					if (res.code == 0) {
						that.ntfList = res.data
					}
				})
			},
			handleDelete(ms) { //删除
				this.$confirm('Determine to delete the current message?', 'Tip:', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.doHandlerDelete(ms)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: 'Deleting data has been cancelled!'
					});
				});
			},
			doHandlerDelete(ms) {
				let that = this
				var reqdata = {
					data: ms
				}
				deleteAuthorCommentService(reqdata).then(res => {
					if (res.code == 0) {
						that.$message({
							message: res.msg,
							icon: 'error',
							center: true
						})
						that.loadData()
					} else {
						that.$message({
							message: res.msg,
							icon: 'error',
							center: true
						})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.header {
		width: 100%;
		height: 70px;
		background-color: #ffffff;
		border-bottom: 1px solid #E5E5E5;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.logo {
			width: 200px;
			text-align: left;

			.icon {
				// width: 120px;
				height: 30px;
				// border:1px solid #f5f5f5;
				margin-left: 25px;
			}
		}

		.search {
			flex: 1;
			padding-left: 25px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			position: relative;

			.s-box {
				width: 80%;
				max-width: 500px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}

			.head-search {
				flex: 1;
			}

			.head-search-btn {
				// width: 50px;
				border-radius: 0px !important;
			}

			.yu-input-val {
				width: 80%;
				max-width: 500px;
				position: absolute;
				left: 25px;
				top: 41px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				z-index: 5;

				.yu-list {
					flex: 1;
					background-color: #FFFFFF;
					box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
					opacity: 1;
					border-radius: 2px;

					.item {
						flex: 1;
						height: 40px;
						line-height: 40px;
						font-size: 14px;
						cursor: pointer;
						padding-left: 20px;
						text-align: left;
					}

					.item:hover {
						background-color: #EEEEEE;
					}
				}

			}
		}

		.user-head {
			margin-right: 20px;
			display: flex;
			flex-direction: row;
			margin-left: 30px;

			.user-item {
				width: 63px;
				height: 70px;
				display: flex;
				justify-content: center;
				align-items: center;
				// background-color: #FFF2E2;
				position: relative;
				cursor: pointer;
				overflow: hidden;

				.icon-box {
					width: 30px;
					height: 30px;
					background-repeat: no-repeat;
					background-position: center;
				}

				.email {
					background-image: url('../../assets/icon/envelope@2x.png');
					background-size: 19px;
				}

				.notion {
					background-image: url('../../assets/icon/bell@2x.png');
					background-size: 16px;
				}

				.user-toux {
					width: 30px;
					height: 30px;
					border-radius: 50%;
				}

				.item-children {
					position: absolute;
					top: 70px;
					right: 0;
					// width: 180px;
					background: #FFFFFF;
					box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
					opacity: 1;
					border-radius: 2px;
					z-index: 5;

					.item-dom {
						height: 50px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 0 20px;
						border-bottom: 1px solid #C4C4C4;

						span {
							color: #000000;
						}

						.clear {
							color: #A2A2A2;
						}

						.clear:hover {
							color: #FF8900;
						}
					}

					.item {
						height: 40px;
						width: 180px;
						text-align: left;
						background-color: #FFFFFF;
						line-height: 40px;
						font-size: 13px;
						cursor: pointer;

						a {
							text-indent: 40px;
							display: inline-block;
							width: 100%;
							height: 100%;
						}
					}

					.item:hover {
						background-color: #FFF2E2;
						color: #FF8900;

						a {
							color: #FF8900;
						}
					}
				}

				.notion-children {
					width: 335px;

					.notion-list {
						height: 50px;
						border-bottom: 1px solid #EAEAEA;
						color: #656565;
						padding: 0 20px;
						position: relative;
						line-height: 50px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						cursor: pointer;

						.name {
							flex: 1;
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
					}

					.notion-list:hover {
						background-color: #FFF2E2;
					}

					.look-all {
						color: #A2A2A2;
						height: 50px;
						line-height: 50px;
						text-align: center;

						.looka:hover {
							color: #FF8900;
						}
					}
				}

				.mess-children {
					width: 400px;

					.mess-list {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						cursor: pointer;
						height: 80px;
						border-bottom: 1px solid #EAEAEA;
						position: relative;

						.head {
							width: 42px;
							height: 42px;
							border-radius: 50%;
							margin: 0 20px;
						}

						.mess {
							flex: 1;
							text-align: left;

							.name {
								font-size: 14px;
								color: #656565;
								line-height: 20px;
							}

							.desc {
								font-size: 13px;
								color: #656565;
								line-height: 20px;
							}

							.time {
								font-size: 12px;
								color: #A2A2A2;
								line-height: 20px;
							}
						}

						.delete-not {
							position: absolute;
							top: 5px;
							right: 5px;
						}
					}

					.mess-list:hover {
						background-color: #FFF2E2;
					}
				}
			}

			.user-item:hover {
				background-color: #FFF2E2;
			}

			.user-item:after {
				display: block;
				content: '';
				width: 1px;
				height: 20px;
				background: #A2A2A2;
				opacity: 0.5;
				position: absolute;
				right: 0;
				top: 25px;
			}

			.user-item:last-child:after {
				width: 0px;
			}

			.userHover:hover,
			.messHover:hover,
			.notionHover:hover {
				overflow: inherit;
			}
		}
	}
</style>
